import React, { useState, useEffect } from 'react';
import './linkform.css';
import api, { baseURL } from '../../axiosInstance';
import { DataGrid } from '@mui/x-data-grid';
import { Button, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Swal from "sweetalert2";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { useMediaQuery } from '@mui/material';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import SendIcon from "@mui/icons-material/Send"; // Import send mail icon
import ForwardToInboxOutlinedIcon from '@mui/icons-material/ForwardToInboxOutlined';
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import axios from 'axios';


function Linkform() {
   const isMobile = useMediaQuery('(max-width:600px)');
      const navigate = useNavigate();
      const { disid,typeid} = useParams() 
      console.log("link form parentid",disid)
      console.log("link form type", typeid)

    
  
    // const parent_id = sessionStorage.getItem('userid');
    
    const [formData, setFormData] = useState({
      parent_id:disid,
      type: typeid,
      name: '',
      username:'',
      lastname:'',
      email: '',
      phone: '',
      address: '',
      language:'',
      organisation:"",
      country_id:""
    });
  
   
    const [ countryList, setCountryList] =  useState();
    const [ errorList, setErrorList] = useState()

    const fectchCountry = async()=> {
      const country =  await axios.get(`${baseURL}/listcountries`) 
      setCountryList(country.data.data)
    }

    useEffect(()=> {

      fectchCountry()

    },[])

    const handleChange = (e) => {
      const { name, value, type } = e.target;
      setFormData((prevData) => ({
        ...prevData,
        [name]: type === 'radio' ? Number(value) : value,
      }));
    };

    const validateForm =() => {
      let errormsg={}
      if(!formData.name)errormsg.name="Name is required"
      if(!formData.username)errormsg.username="Username is required"
      if(!formData.lastname)errormsg.lastname="Lastname is required"
      if(!formData.email)errormsg.email="Email is required"
      if(!formData.phone)errormsg.phone="Phone is required"
      if(!formData.language)errormsg.language="Language is required"
      if(!formData.organisation)errormsg.organisation="Organisation is required"
      if(!formData.country_id)errormsg.country_id="Country is required"

      setErrorList(errormsg)
      return Object.keys(errormsg).length==0


    }

    const handleFormSubmit = (e)=> {
          e.preventDefault()
          if(validateForm()){
            handleSubmit(formData)
          }
    }

    const handleSubmit = async (formData) => {
      // e.preventDefault();
      const cleanedFormData = Object.keys(formData).reduce((acc, key) => {
        if (formData[key] !== "" && formData[key] !== null && formData[key] !== undefined) {
          acc[key] = formData[key];
        }
        return acc;
      }, {});
      
      try {
        {
          // Add new client
            console.log("create link", formData)
          const response = await axios.post(`${baseURL}/register`,  cleanedFormData);
          if (response.status === 200) {
            // alert('Client added successfully!');
            Swal.fire('Success!', 'Client added successfully!', 'success');
  
          }
        }
  
        // Reset form
        setFormData({ parent_id:disid, 
          type: typeid,
          name: '',
          username:'',
          lastname:'',
          email: '', 
          phone: '',
          address: '',
          language:'',
          organisation:"",
          country_id:""

        
        });
      } catch (error) {
        // alert(`Error: ${error?.response?.data?.error}`);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error?.response?.data?.error || "Something went wrong!",
        });
        console.error(error);
      }
    };
  
  return (
    <div className='distributerbgimage rounded-3 shadow d-flex justify-content-center align-items-center vh-100 p-4'>
    <div className='p-4 shadow rounded-5 d-flex flex-column' style={{ width: "900px" ,maxHeight:"500px",overflow:"auto"}}>
      <div className='flex-grow-1 '>
      <form onSubmit={handleFormSubmit}>
        <div className='row' >
        {[
          { label: 'Name', name: 'name', type: 'text', required: true },
          {label:"Username", name:'username', type:"text", required:true},
          {label:"Lastname", name:'lastname', type:"text", required:true},
        



          


          // {label:"0rganisation", name:"organisation", type:"text", required:true},
          // { label: 'Email', name: 'email', type: 'email',required:true  },
          // { label: 'Phone Number', name: 'phone', type: 'text',required:true},
          ].map((field) => (
          <div key={field.name} className='col-md-6 col-12'>
            <label htmlFor={field.name} className='form-label distributerfont'>{field.label}</label>
            <input
              className='form-control'
              name={field.name}
              type={field.type}
              placeholder={field.label}
              value={formData[field.name]}
              onChange={handleChange}
              required={field.required}
            />
          </div>
        ))}
         {[
          // { label: 'Name', name: 'name', type: 'text', required: true },
          // {label:"Username", name:'username', type:"text", required:true},
          // {label:"Lastname", name:'lastname', type:"text", required:true},
          // {label:"Lastname", name:'lastname', type:"text", required:true},


          {label:"0rganisation", name:"organisation", type:"text", required:true},
          { label: 'Email', name: 'email', type: 'email',required:true  },
          { label: 'Phone Number', name: 'phone', type: 'text',required:true},
          ].map((field) => (
          <div key={field.name} className='col-md-6 col-12'>
            <label htmlFor={field.name} className='form-label distributerfont'>{field.label}</label>
            <input
              className='form-control'
              name={field.name}
              type={field.type}
              placeholder={field.label}
              value={formData[field.name]}
              onChange={handleChange}
              required={field.required}
            />
          </div>
        ))}

        

        <div className='col-md-6 col-12'>
          <label htmlFor='address' className='form-label distributerfont'>Address</label>
          <textarea
            className='form-control'
            placeholder='Address'
            name='address'
            value={formData.address}
            onChange={handleChange}
          />
        </div>

        <div className='col-md-6 col-12'>
          <label htmlFor='language' className='form-label distributerfont'>Language</label>
          <select
            className='form-control'
            name='language'
            value={formData.language}
            onChange={handleChange}
            required
          >
            <option value="">Select Language</option>
            <option value="English">English</option>
            <option value="Arabic">Arabic</option>
            <option value="Malayalam">Malayalam</option>
          </select>
        </div>

        <div className='col-md-6 col-12'>
          <label htmlFor='country' className='form-label distributerfont' >Country</label>
          <select className='form-control'
          name='country_id'
          value={formData.country_id}
          onChange={handleChange}
          required
          >
          <option value=""></option>
          {
            countryList?.map((country)=> (
              <option value={country.id}>{country.name}</option>
            ))
          }

          </select>
        </div> 


        

        </div>
       
        <div className='d-flex justify-content-center align-items-center py-2 mt-0' >
          <Button variant="outlined" color="secondary" >Cancel</Button>
          <Button type='submit' variant="contained" color="primary" className='m-1' >
            Submit
          </Button>
        </div>

        
      </form>
      </div>
      
    </div>
  </div>
  )
}

export default Linkform